<template>
  <div class="width-100 mainBox flex-column justify-content-start align-items-center" style="min-width: 1200px">
    <!--    顶部菜单栏-->
    <tab class="fixed" selectTab="5" style="min-width: 1200px"></tab>

    <img src="@/assets/image/banner3.jpg" width="100%" alt="" />
    <div class="main flex-row justify-content-spaceBetween align-items-center margin-ts margin-bs border-b">
      <p class="fs-mid grey">当前位置：首页 > 投资项目</p>
      <!--      <div class="flex-row justify-content-center border align-items-center searchBox">-->
      <!--        <input type="text" class="fs-mid search margin-r" placeholder="点击输入搜索新闻/关键词" />-->
      <!--        <van-icon name="search" color="#999999" class="margin-l" size="20" />-->
      <!--      </div>-->
    </div>
    <div
      @mouseenter="addClassload(index)"
      @mouseleave="removeClassload()"
      @click="newsDetail(item.id)"
      :class="{ 'bg-slightGrey': classenable && current === index }"
      v-for="(item, index) in profile"
      :key="index"
      class="main pointer select paddingTb flex-row justify-content-around align-items-star"
    >
      <van-image width="18%" class="height140 van-overflow-hidden margin-l" :src="imagePrefix + item.poster" alt="" />
      <div class="width-75 margin-r">
        <p class="fs-big fw-mid margin-bs">{{ item.title }}</p>
        <p class="fs-mid lineHeight2 cutText3">{{ item.summary }}<span class="myBlue" style="display: inline">[查看详细]</span></p>
      </div>
    </div>
    <van-pagination @change="mountedData" class="margin-ts" v-model="currentPage" :total-items="total" :items-per-page="pageSize" :show-page-size="5">
      <template #prev-text>
        <van-icon name="arrow-left" />
      </template>
      <template #next-text>
        <van-icon name="arrow" />
      </template>
      <template #page="{ text }">{{ text }}</template>
    </van-pagination>
    <backBtn></backBtn>

    <footerBox class="margin-t"></footerBox>
  </div>
</template>
<script>
import tab from '@/components/tab.vue';
import footerBox from '@/components/footer.vue';
import backBtn from '@/components/backBtn.vue';
import newsApi from '@/api/newsApi';
import config from '@/config';

export default {
  name: 'profile',
  components: {
    tab,
    footerBox,
    backBtn
  },
  data() {
    return {
      imagePrefix: config.IMAGE_PREFIX,
      currentPage: 1,
      pageSize: 4,
      classenable: false,
      current: 0,
      total: 0,
      profile: []
    };
  },
  mounted() {},

  created() {
    this.mountedData();
  },
  methods: {
    mountedData() {
      newsApi
        .list({ status: '1', params: { pageNum: this.currentPage, pageSize: this.pageSize, likeType: '015' } })
        .then((res) => {
          this.total = res.total;
          this.profile = res.rows;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    newsDetail(id) {
      let text = this.$router.resolve({ path: '/newsDetail', query: { type: 'profile', newsId: id } });
      // 打开一个新的页面
      window.open(text.href, '_blank');
    },
    addClassload(e) {
      this.classenable = true;
      this.current = e;
    },
    removeClassload() {
      this.classenable = false;
      // this.current=index;
    },
    jumpTo(e, m) {
      this.$router.push({ path: e, params: { Id: m } });
    }
  }
};
</script>

<style lang="less" scoped>
.fixed {
  position: fixed;
  top: 0;
  z-index: 99;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
.mainBox {
  height: 200px;
  padding-top: 60px;
}
.search {
  border: none !important;
}
.height140 {
  height: 140px;
}
.searchBox {
  padding: 4px 10px;
  border-radius: 5px;
}
.border-b {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 20px;
}
</style>
<style>
.van-pagination__item--active {
  background-color: rgb(11, 73, 158) !important;
  color: #ffffff !important;
}
.van-pagination__item {
  min-width: 30px;
  height: 30px;
  margin: 0 3px;
  border: 1px solid #eeeeee;
  color: #666666;
}
</style>
